var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#25282C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#2B2F32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5492 21.4674L14.8879 26.8694C14.7644 27.0109 14.5911 27.0834 14.4167 27.0834C14.2709 27.0834 14.1245 27.0327 14.0061 26.9294C13.746 26.7024 13.7191 26.3076 13.9461 26.0475L18.7558 20.4757L19.5492 21.4674ZM21.2449 19.5244L26.0546 13.9526C26.2816 13.6925 26.2547 13.2978 25.9946 13.0708C25.7346 12.8438 25.3396 12.8706 25.1128 13.1307L20.4515 18.5326L21.2449 19.5244Z",
    fill: "#F4FD84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7086 27.0834H23.4586C23.2687 27.0834 23.0892 26.9971 22.9706 26.8488L12.8039 13.9322C12.6539 13.7446 12.6246 13.4875 12.7287 13.271C12.8328 13.0545 13.0517 12.9167 13.2919 12.9167H16.5419C16.7319 12.9167 16.9114 13.0031 17.0299 13.1513L27.1966 26.068C27.3467 26.2556 27.3759 26.5127 27.2719 26.7292C27.1678 26.9457 26.9489 27.0834 26.7086 27.0834ZM23.759 25.8334H25.4082L16.2415 14.1667H14.5924L23.759 25.8334Z",
    fill: "#F4FD84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.00ec66a7503c0cba6455b336943010b2.svg";
export { ForwardRef as ReactComponent };